import React, { Component } from 'react'
import Textarea from 'react-textarea-autosize'
import './TextAreaField.scss'

export class TextAreaField extends Component {
  static defaultProps = {
    minRows: 2,
    maxRows: 5,
    input: {
      value: '',
      onChange: () => null,
    },
    meta: {},
  }

  render() {
    const {
      label,
      minRows,
      maxRows,
      meta: { touched, error },
    } = this.props
    const { value, onChange } = this.props.input
    return (
      <div className="textarea-field md-field">
        {label && <label>{label}</label>}
        <Textarea
          minRows={minRows}
          maxRows={maxRows}
          placeholder={this.props.placeholder}
          value={value}
          onChange={onChange}
          onBlur={() => this.props.input.onBlur()}
          onFocus={() => this.props.input.onFocus()}
        />
        {touched && error && <span className="error">{error}</span>}
      </div>
    )
  }
}

//Validations
export const validateRequiredText = (value) => value && !!value.trim()
